import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Attaches a unique x-request-id header to every outgoing HTTP request.
 *
 * The backend stamps the same ID on its response header and includes it in
 * every log line for that request.  When a user reports a problem, grab the
 * request ID from the browser's Network tab → Response Headers → x-request-id
 * and search the server logs for that value to find every log entry related to
 * that specific request instantly.
 */
@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // crypto.randomUUID() is available in all modern browsers (Chromium 92+,
    // Firefox 95+, Safari 15.4+) and does not require importing a library.
    const requestId = crypto.randomUUID();

    const cloned = req.clone({
      setHeaders: { 'x-request-id': requestId },
    });

    return next.handle(cloned);
  }
}
